import { api } from "@/lib/api";

const withTenant = (params, tenantId) =>
  tenantId ? { ...(params || {}), tenant_id: tenantId } : params;

export const TimetableAPI = {
  listByClass: ({ classId, sectionId, institutionId }, tenantId) =>
    api.get("/timetable/slots", { params: withTenant({
      class_id: classId,
      ...(sectionId ? { section_id: sectionId } : {}),
      ...(institutionId ? { institution_id: institutionId } : {}),
    }, tenantId) }).then((r) => r.data),
  listByTeacher: ({ teacherId, institutionId }, tenantId) =>
    api.get("/timetable/slots", { params: withTenant({
      teacher_id: teacherId,
      ...(institutionId ? { institution_id: institutionId } : {}),
    }, tenantId) }).then((r) => r.data),
  upsert: (body, tenantId) =>
    api.post("/timetable/slots", body, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  remove: (id, tenantId) =>
    api.delete(`/timetable/slots/${id}`, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  teachers: (institution_id, tenantId) =>
    api.get("/timetable/teachers", { params: withTenant({ institution_id }, tenantId) }).then((r) => r.data),
};

// Used by the "Exam Schedule" tab — wraps the existing gradebook list + new PATCH.
export const ExamScheduleAPI = {
  patch: (eid, body, tenantId) =>
    api.patch(`/gradebook/exams/${eid}`, body, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
};
